
import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import "./styles/App.css";
// import Background from "./components/background/Hero";
import BallsBackground from "./components/background/background1/FloatingBalls"
import ScrollToTopButton from "./components/ScrollToTopButton"

import { useEffect } from "react";
import { initGA, trackPageView } from "./analytics";

function App() {

    useEffect(() => {
    initGA();
    trackPageView();
  }, []);

  return (
    <div>
      <Navbar />
      <Hero />
      <BallsBackground />
      <About />
      <Experience />
      <Projects />
      <Contact />
      {/* <BallsBackground /> */}
      {/* <Background /> */}
      <ScrollToTopButton />
    </div>
  );
}

export default App;
